<!-- 文章 -->
<template>
  <div class="article-box">
    <p class="title">{{ details.title }}</p>
    <div class="art-tips">
      <span>{{ details.author }}</span>
      <span>{{ details.create_time }}</span>
    </div>
    <div class="content" v-html="details.content"></div>
  </div>
</template>
<script>
import { getArticleDetails } from "@/api/apiData";
export default {
  components: {},
  inject: ["getWechatApi"],
  data() {
    return {
      articleId: "",
      details: "",

    };
  },
  computed: {},
  methods: {
    getDetails() {
      var that = this;
      var id = that.articleId;
      getArticleDetails({ article_id: id }).then((res) => {
        if (res.code == 1) {
          that.details = res.data;
          var img;
          if (res.data.cover == "") {
            img = "https://ncxtyjrwork.nccloudmedia.com/favicon.ico";
          } else {
            img = res.data.cover;
          }
          this.getWechatApi(
            `#${that.$route.fullPath}&share`,
            res.data.title,
            img
          );
        }
      });
    },
  },
  created() {
    this.articleId = this.$route.query.id;
   
  },
  mounted() {
    this.getDetails();
  },
};
</script>
<style lang='less' scoped>
.article-box {
  padding: 0.2rem 0.32rem;
  .title {
    font-size: 0.36rem;
    font-weight: bold;
    line-height: 0.48rem;
    color: rgba(51, 51, 51, 1);
  }
  .art-tips {
    margin-top: 0.2rem;
    font-size: 0.26rem;
    font-weight: 400;
    color: rgba(75, 183, 255, 1);
    span:last-child {
      color: #808080;
      margin-left: 0.2rem;
    }
  }
  .content {
    padding: 0.4rem 0 0;
    font-size: 0.3rem;
    font-weight: 400;
    line-height: 0.56rem;
    color: rgba(51, 51, 51, 1);
  }
  /deep/.content img {
    max-width: 100%;
    margin: auto;
  }
}
</style>